import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { SftpImportConfigurationWorkflow, ImportType, DataType, CalculationModeType, InventoryIdentificationMatchMode, SupplierIdentificationMatchMode, getCalculationModeTypeDescriptions, getInventoryIdentificationMatchModeDescriptions, getSupplierIdentificationMatchModeDescriptions } from '../../../store/Models/Api/SftpImportModels';

interface DefaultHandlingInfoSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
}

type DefaultHandlingInfoSectionProps = DefaultHandlingInfoSectionLocalProps & ToxnotComponentProperties;

class DefaultHandlingInfoSectionComponent extends ToxnotComponent<DefaultHandlingInfoSectionProps> {
    public render() {
        const { configData, appServices } = this.props;
        
        const calculationModeDescriptions = getCalculationModeTypeDescriptions(appServices);
        const inventoryMatchModeDescriptions = getInventoryIdentificationMatchModeDescriptions(appServices);
        const supplierMatchModeDescriptions = getSupplierIdentificationMatchModeDescriptions(appServices);

        return (
            <>
                <p><strong>{this.localizeString("Has Header")}:</strong> {configData.hasHeader ? 'Yes' : 'No'}</p>
                {configData.hasHeader && <p><strong>{this.localizeString("Header End Row")}:</strong> {configData.headerEndRow}</p>}
                <p><strong>{this.localizeString("Has Footer")}:</strong> {configData.hasFooter ? 'Yes' : 'No'}</p>
                {configData.hasFooter && <p><strong>{this.localizeString("Footer Start Row")}:</strong> {configData.footerStartRow}</p>}
                <p><strong>{this.localizeString("Excel Tab to Import")}:</strong> {configData.sheetName}</p>
                
                {configData.importType !== ImportType.Suppliers && configData.dataType === DataType.Bom && (
                    <>
                        <hr />
                        <p><strong>{this.localizeString("Tags")}:</strong> {(configData.tags && configData.tags.length > 0) ? configData.tags.join(', ') : ''}</p>
                        <p><strong>{this.localizeString("Auto-calculation Mode")}:</strong> {calculationModeDescriptions[configData.calculationMode as CalculationModeType] || configData.calculationMode}</p>
                        <p><strong>{this.localizeString("Extract and Link Materials")}:</strong> {configData.shouldExtractAndLink ? 'Yes' : 'No'}</p>
                        {configData.shouldExtractAndLink && (
                        <div>
                            <p><strong>{this.localizeString("Overwrite Existing Sub-Materials")}:</strong> {configData.extractAndLinkShouldOverwriteSubmaterials ? 'Yes' : 'No'}</p>
                            <p><strong>{this.localizeString("Extract from Lowest Level")}:</strong> {configData.shouldExtractLeafiestMaterials ? 'Yes' : 'No'}</p>
                        </div>
                    )}
                        {!configData.shouldExtractAndLink && (
                            <p><strong>{this.localizeString("Don't automatically link materials in products with existing materials")}:</strong> {!configData.shouldMatchMaterials ? 'Yes' : 'No'}</p>
                        )}
                        <p><strong>{this.localizeString("Product/Material Match")}:</strong> {inventoryMatchModeDescriptions[configData.inventoryIdentificationMatchMode as InventoryIdentificationMatchMode] || configData.inventoryIdentificationMatchMode}</p>
                        <p><strong>{this.localizeString("Supplier Match")}:</strong> {supplierMatchModeDescriptions[configData.supplierIdentificationMatchMode as SupplierIdentificationMatchMode] || configData.supplierIdentificationMatchMode}</p>
                    </>
                )}
            </>
        );
    }
}

export const DefaultHandlingInfoSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(DefaultHandlingInfoSectionComponent);
